import React from 'react';
import { motion } from 'framer-motion';
const screenshots = [{
  url: 'https://cdn.magicpatterns.com/uploads/hva6nk7p6kpaYG9dE4qdDi/0x0ss_(13).png',
  alt: 'Bring Your Characters to Life',
  rotation: -2
}, {
  url: 'https://cdn.magicpatterns.com/uploads/9LKQWigQphsyZSTS5JfeeY/0x0ss_(10).png',
  alt: 'Create from Your Photos',
  rotation: 3
}, {
  url: 'https://cdn.magicpatterns.com/uploads/3d53R8iWNgMFve5iBME6Gs/0x0ss_(11).png',
  alt: 'Anything Can Become a Comic',
  rotation: -1
}, {
  url: 'https://cdn.magicpatterns.com/uploads/dK37MDX2GSoQ47B2mX6LMK/0x0ss_(12).png',
  alt: 'Build Your Own Comic Series',
  rotation: 2
}, {
  url: 'https://cdn.magicpatterns.com/uploads/gdFdN6VWusQza8AhWJJvaw/0x0ss_(9).png',
  alt: 'Create Your Story Instantly',
  rotation: -3
}];
export function AppShowcase() {
  return <section id="showcase" className="py-24 bg-halftone-blue overflow-hidden border-y-8 border-black" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12 text-center" data-id="element-10">
        <motion.h2 initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="font-bangers text-5xl md:text-6xl text-white text-stroke-black italic" data-id="element-11">
          See It In Action!
        </motion.h2>
      </div>

      <div className="relative w-full overflow-x-auto py-10" data-id="element-12">
        <div className="flex justify-center flex-wrap gap-8 md:gap-12 px-10" data-id="element-13">
          {screenshots.map((screen, index) => <div key={index} className="relative w-[260px] md:w-[300px] flex-shrink-0 group" style={{
          transform: `rotate(${screen.rotation}deg)`
        }} data-id="element-14">
              <div className="rounded-[2.5rem] comic-border bg-black p-2 comic-shadow transition-transform duration-300 group-hover:-translate-y-4 group-hover:rotate-0" data-id="element-15">
                <div className="rounded-[2rem] overflow-hidden bg-white relative" data-id="element-16">
                  <img src={screen.url} alt={screen.alt} className="w-full h-auto object-cover" data-id="element-17" />
                </div>
              </div>
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-[120%] text-center" data-id="element-18">
                <span className="inline-block bg-white text-black font-bangers text-xl px-4 py-1 comic-border comic-shadow-sm" data-id="element-19">
                  {screen.alt}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}